<template>
  <div class="text-center p-3 mb-5">内容源自互联网 · <a href="mailto:hi@uxlib.cn"  class="copyrights">投稿</a> · 整理：<a class="copyrights" href="https://uxlib.net/?ref=uxchalleges" target="_blank" >UXLib</a> · 🫶 Respect! <a class="copyrights" target="_blank" href="https://uxtools.co/challenges/">UX challenges</a></div>
</template>
